// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2Gxwy","col":"styles_col__2uVFY"};